import { Col, Row, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import BgSVG from "./bgSVG";
import useForm from "../../../hooks/useForm";
import { useDispatch, useSelector } from "react-redux";
import * as AuthActions from "../../../store/auth/actions";
import { useEffect, useState } from "react";
import "./style.scss";
import { textIdentifier } from "../../../textIdentifier";

export default function Signin(props) {
  const dispatch = useDispatch();
  const {errorMessage} = useSelector(state => state.auth)
  const {lang} = useSelector(state => state.main)
  const [error, setError] = useState("")

  const handleSubmit = async (values) => {
    dispatch(
      AuthActions.loginUser({
        username: values.email,
        password: values.password,
      })
    );
  };

  const signInForm = useForm({
    initialValues: {
      email: "",
      password: "",
    },
    validate: (values) => {
      const errors = {};
      const emailValidate = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      // if (!values.email.trim() || !emailValidate.test(values.email)) {
      //   errors.email = "Invalid email, please enter a valid email";
      // }
      if (!values.password) {
        errors.password = "Invalid password, please enter a valid password";
      }
      if (error) {
        setError("")
      }
      return errors;
    },
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  useEffect(() => {
    if (errorMessage) {
     signInForm.setSubmitting() 
     setError(errorMessage?.data?.message)
    }
  },[errorMessage])
  return (
    <main className="signin">
      <Row className="gx-0 h-100 w-100">
        <Col xs={6}>
          <div className="left-container">
            {/* logo  */}
            <div className="logo">
              <img
                src="/static/images/svg/logo.svg"
                alt="logo"
                width={225}
                height={64}
              />
            </div>

            {/* heading  */}
            <div className="headingContainer">
              <h1>Login</h1>
              <span className="logo-subheading">
                Login with your data to proceed
              </span>
            </div>

            {/* login form  */}
            <form onSubmit={signInForm.handleSubmit}>
              <div className="form-group">
                <label htmlFor="email" className="form-label">
                  Email
                </label>
                <input
                  // type="email"
                  className="form-control"
                  placeholder= "name@domian.com"
                  id="email"
                  value={signInForm.values.email}
                  onChange={signInForm.handleChange}
                />
                {signInForm.errors?.email && (
                  <div id="helperText" className="form-text">
                    {signInForm.errors.email}
                  </div>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="password" className="form-label">
                  Password
                </label>
                <input
                  type="password"
                  placeholder="Min. 6 Characters"
                  className="form-control"
                  id="password"
                  value={signInForm.values.password}
                  onChange={signInForm.handleChange}
                />
                {signInForm.errors?.password && (
                  <div id="helperText" className="form-text">
                    {signInForm.errors.password}
                  </div>
                )}
              </div>

              {error && (
              <div className="form-group">
                <div id="helperText" className="form-text">
                  {error}
                </div>
              </div>
              )}

              <div className="form-group text-center">
                <button
                  disabled={signInForm.isSubmitting}
                  className="btn-contained"
                  type="submit"
                >
                  {signInForm.isSubmitting ? (
                    <Spinner variant="secondary" animation="border" />
                  ) : (
                    "Login"
                  )}
                </button>
                <Link to={"/forgot-password"}>Forgot Password ?</Link>
              </div>
            </form>
          </div>
        </Col>

        <Col xs={6}>
          <div className="login-background">
            <BgSVG />
          </div>
        </Col>
      </Row>
    </main>
  );
}
